
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/2025-punta-cana-retreat",
      function () {
        return require("private-next-pages/blog/2025-punta-cana-retreat.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/2025-punta-cana-retreat"])
      });
    }
  